import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "input"]

  connect() {
    this.currentRating = 0
  }

  select(event) {
    const value = parseInt(event.currentTarget.dataset.value)
    this.currentRating = value
    this.inputTargets[value - 1].checked = true
    this.updateStars(value)
  }

  hover(event) {
    const value = parseInt(event.currentTarget.dataset.value)
    this.updateStars(value)
  }

  reset() {
    this.updateStars(this.currentRating)
  }

  updateStars(count) {
    this.starTargets.forEach((star, index) => {
      if (index < count) {
        star.classList.remove("text-gray-200")
        star.classList.add("text-yellow-400")
      } else {
        star.classList.remove("text-yellow-400")
        star.classList.add("text-gray-200")
      }
    })
  }
}
